export const V3WithdrawalTokens: Record<
  string,
  {
    id: number
    symbol: string
    chains: Record<
      string,
      {
        address: string
        chainId: number
        decimals: number
        fastWithdraw: boolean
      }
    >
  }
> = {
  '140': {
    id: 140,
    chains: {
      '7': {
        address: '0x176211869ca2b568f2a7d4ee941e073a821ee1ff',
        chainId: 7,
        decimals: 6,
        fastWithdraw: false,
      },
      '5': {
        address: '0x3355df6d4c9c3035724fd0e3914de96a5a83aaf4',
        chainId: 5,
        decimals: 6,
        fastWithdraw: false,
      },
      '9': {
        address: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
        chainId: 9,
        decimals: 6,
        fastWithdraw: false,
      },
      '2': {
        address: '0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e',
        chainId: 2,
        decimals: 6,
        fastWithdraw: false,
      },
      '4': {
        address: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
        chainId: 4,
        decimals: 6,
        fastWithdraw: false,
      },
      '1': {
        address: '0x3c499c542cef5e3811e1192ce70d8cc03d5c3359',
        chainId: 1,
        decimals: 6,
        fastWithdraw: false,
      },
      '10': {
        address: '0x0b2c639c533813f4aa9d7837caf62653d097ff85',
        chainId: 10,
        decimals: 6,
        fastWithdraw: false,
      },
    },
    symbol: 'USDC',
  },
  '141': {
    id: 141,
    chains: {
      '1': {
        address: '0xc2132d05d31c914a87c6611c10748aeb04b58e8f',
        chainId: 1,
        decimals: 6,
        fastWithdraw: false,
      },
      '2': {
        address: '0x9702230a8ea53601f5cd2dc00fdbc13d4df4a8c7',
        chainId: 2,
        decimals: 6,
        fastWithdraw: false,
      },
      '4': {
        address: '0xdac17f958d2ee523a2206206994597c13d831ec7',
        chainId: 4,
        decimals: 6,
        fastWithdraw: false,
      },
      '5': {
        address: '0x493257fd37edb34451f62edf8d2a0c418852ba4c',
        chainId: 1,
        decimals: 6,
        fastWithdraw: false,
      },
      '7': {
        address: '0xa219439258ca9da29e9cc4ce5596924745e12b93',
        chainId: 7,
        decimals: 6,
        fastWithdraw: false,
      },
      '9': {
        address: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
        chainId: 9,
        decimals: 6,
        fastWithdraw: false,
      },
      '10': {
        address: '0x94b008aa00579c1307b0ef2c499ad98a8ce58e58',
        chainId: 10,
        decimals: 6,
        fastWithdraw: false,
      },
    },
    symbol: 'USDT',
  },
  '142': {
    id: 142,
    chains: {
      '4': {
        address: '0x2260fac5e5542a773aa44fbcfedf7c193bc2c599',
        chainId: 4,
        decimals: 8,
        fastWithdraw: false,
      },
    },
    symbol: 'wBTC',
  },
  '143': {
    id: 143,
    chains: {
      '4': {
        address: '0xb50721bcf8d664c30412cfbc6cf7a15145234ad1',
        chainId: 4,
        decimals: 18,
        fastWithdraw: false,
      },
      '9': {
        address: '0x912ce59144191c1204e64559fe8253a0e49e6548',
        chainId: 9,
        decimals: 18,
        fastWithdraw: false,
      },
    },
    symbol: 'ARB',
  },
  '144': {
    id: 144,
    chains: {
      '10': {
        address: '0x4200000000000000000000000000000000000042',
        chainId: 10,
        decimals: 18,
        fastWithdraw: false,
      },
    },
    symbol: 'OP',
  },
  '33': {
    id: 33,
    chains: {
      '1': {
        address: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
        chainId: 1,
        decimals: 18,
        fastWithdraw: false,
      },
    },
    symbol: 'MATIC',
  },
  '34': {
    id: 34,
    chains: {
      '2': {
        address: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
        chainId: 2,
        decimals: 18,
        fastWithdraw: false,
      },
    },
    symbol: 'AVAX',
  },
  '35': {
    id: 35,
    chains: {
      '15': {
        address: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
        chainId: 15,
        decimals: 18,
        fastWithdraw: false,
      },
      '3': {
        address: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
        chainId: 3,
        decimals: 18,
        fastWithdraw: false,
      },
    },
    symbol: 'BNB',
  },
  '36': {
    id: 36,
    chains: {
      '4': {
        address: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
        chainId: 4,
        decimals: 18,
        fastWithdraw: false,
      },
      '5': {
        address: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
        chainId: 5,
        decimals: 18,
        fastWithdraw: false,
      },
      '7': {
        address: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
        chainId: 7,
        decimals: 18,
        fastWithdraw: false,
      },
      '9': {
        address: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
        chainId: 9,
        decimals: 18,
        fastWithdraw: false,
      },
      '10': {
        address: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
        chainId: 10,
        decimals: 18,
        fastWithdraw: false,
      },
      '11': {
        address: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
        chainId: 11,
        decimals: 18,
        fastWithdraw: false,
      },
    },
    symbol: 'ETH',
  },
} as const
